import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { RadioCheckBoxEnum } from "../../common/radio.checkbox.enums";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_468 implements Validator {

    public static id = 'CTRL_468';
    private message = 'error.ctr_468';


    public LOG: LogService = new LogService(CTRL_468);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_468.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const servicesNameWithStepId = map.get(ctrl.value.rgCtrls.services);
                const indicationNomQualificationPersonnelOuiNameWithStepId = map.get(ctrl.value.rgCtrls.indicationNomQualificationPersonnelOui);
                const servicesCtrl = form.controls[servicesNameWithStepId];
                const indicationNomQualificationPersonnelOuiCtrl = form.controls[indicationNomQualificationPersonnelOuiNameWithStepId];
                if (indicationNomQualificationPersonnelOuiCtrl.value !== null && servicesCtrl.value !== RadioCheckBoxEnum.servicesValue) {
                     // placer le message d'erreur
                     form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}